"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageHeader = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../Icons");

var _Button = require("../Button");

var _typography = require("../typography");

var _helpers = require("../../helpers");

var _AvatarText = require("./AvatarText");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Wrapper",
  componentId: "sc-16v8p75-0"
})(["display:flex;flex-direction:row;min-width:100%;border-top:1.4px solid ", ";padding:", " ", " 0;"], (0, _helpers.color)('dark-3'), (0, _helpers.getSpacing)('medium'), (0, _helpers.getSpacing)('medium'));

var ActionHeader = _styledComponents.default.div.withConfig({
  displayName: "ActionHeader",
  componentId: "sc-16v8p75-1"
})(["display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;@media ", "{display:flex;flex-direction:row;justify-content:space-between;align-items:flex-start;flex-grow:1;}"], (0, _helpers.breakpoint)('minTablet'));

var MetaInfo = _styledComponents.default.div.withConfig({
  displayName: "MetaInfo",
  componentId: "sc-16v8p75-2"
})(["display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;flex-grow:1;&&{margin-top:0;}margin-bottom:", ";@media ", "{margin-bottom:0;}"], (0, _helpers.getSpacing)('small'), (0, _helpers.breakpoint)('minTablet'));

var SendInfo = _styledComponents.default.div.withConfig({
  displayName: "SendInfo",
  componentId: "sc-16v8p75-3"
})(["display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;flex-grow:1;@media ", "{flex-direction:row;}"], (0, _helpers.breakpoint)('minTablet'));

var SenderName = (0, _styledComponents.default)(_typography.Strong).withConfig({
  displayName: "SenderName",
  componentId: "sc-16v8p75-4"
})(["@media ", "{margin-bottom:0;margin-right:", ";}"], (0, _helpers.breakpoint)('minTablet'), (0, _helpers.getSpacing)('small'));
var SentAt = (0, _styledComponents.default)(_typography.Subtitle2).withConfig({
  displayName: "SentAt",
  componentId: "sc-16v8p75-5"
})([""]);
var Subject = (0, _styledComponents.default)(_typography.Strong).withConfig({
  displayName: "Subject",
  componentId: "sc-16v8p75-6"
})([""]);
var Recipient = (0, _styledComponents.default)(_typography.Subtitle2).withConfig({
  displayName: "Recipient",
  componentId: "sc-16v8p75-7"
})([""]);

var MessageActions = _styledComponents.default.div.withConfig({
  displayName: "MessageActions",
  componentId: "sc-16v8p75-8"
})(["button{margin-left:1rem;white-space:nowrap;}"]);

var MessageHeader = function MessageHeader(_ref) {
  var sender = _ref.sender,
      recipient = _ref.recipient,
      createdAt = _ref.createdAt,
      subject = _ref.subject,
      disabled = _ref.disabled,
      isSender = _ref.isSender,
      showRecipient = _ref.showRecipient,
      avatar = _ref.avatar,
      handleReply = _ref.handleReply;
  return React.createElement(Wrapper, null, avatar || React.createElement(_AvatarText.AvatarText, {
    isSender: isSender
  }, (0, _helpers.formatInitials)(sender)), React.createElement(ActionHeader, null, React.createElement(MetaInfo, null, React.createElement(SendInfo, null, React.createElement(SenderName, null, (0, _helpers.formatFullName)(sender)), React.createElement(SentAt, null, createdAt)), React.createElement(Subject, null, subject), showRecipient && React.createElement(Recipient, null, "To: ", (0, _helpers.formatFullName)(recipient), " (", recipient.email, ")")), React.createElement(MessageActions, null, React.createElement(_Button.Button, {
    buttonStyle: "secondary",
    onClick: handleReply,
    disabled: disabled,
    icon: _Icons.ReplyIcon
  }, "Reply"))));
};

exports.MessageHeader = MessageHeader;